__turbopack_context__.v({
  "articleContent": "lcResourcesArticleItem-module-scss-module__LXyg4W__articleContent",
  "articleImage": "lcResourcesArticleItem-module-scss-module__LXyg4W__articleImage",
  "category": "lcResourcesArticleItem-module-scss-module__LXyg4W__category",
  "categorySection": "lcResourcesArticleItem-module-scss-module__LXyg4W__categorySection",
  "contentSection": "lcResourcesArticleItem-module-scss-module__LXyg4W__contentSection",
  "date": "lcResourcesArticleItem-module-scss-module__LXyg4W__date",
  "description": "lcResourcesArticleItem-module-scss-module__LXyg4W__description",
  "subTitle": "lcResourcesArticleItem-module-scss-module__LXyg4W__subTitle",
  "time": "lcResourcesArticleItem-module-scss-module__LXyg4W__time",
});
